import { createContext, useContext } from 'react';

/**
 * Context to know which screen size we are currently in.
 */
const ScreenContext = createContext(false);
ScreenContext.displayName = 'Screen Size Context';

/**
 * Hook to use the screen context.
 * @returns {React.Context}
 */
const useScreenContext = () => useContext(ScreenContext);

export { ScreenContext, useScreenContext };
